/**
 * Affichage conditionnel de la bulle de recherche globale
 *
 * Rôle : Affiche SearchBubble (bouton fixe en bas à droite) uniquement si l'utilisateur est connecté
 * et n'est pas sur la page d'accueil. Affiche une bulle d'aide au survol.
 * Technologies : Next.js (usePathname), next-auth (useSession), React
 */
"use client";

import { usePathname } from "next/navigation";
import { useSession } from "next-auth/react";
import { useState } from "react";
import SearchBubble from "./SearchBubble";

export default function ConditionalSearchBubble() {
  const pathname = usePathname();
  const { status } = useSession();
  const isLoggedIn = status === "authenticated";
  const [isHovered, setIsHovered] = useState(false);
  
  // Ne pas afficher le bouton de recherche sur la page d'onboarding ou si l'utilisateur n'est pas connecté
  if (pathname === "/" || !isLoggedIn) {
    return null;
  }
  
  return (
    <div 
      className="fixed bottom-4 right-4 z-50"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <SearchBubble />
      
      {/* Bulle d'aide à la recherche - visible au survol */}
      {isHovered && (
        <div className="absolute bottom-16 right-0">
          {/* Flèche pointant vers le bouton de recherche */}
          <div className="absolute bottom-0 right-6 w-0 h-0 border-l-4 border-r-4 border-t-8 border-l-transparent border-r-transparent border-t-white"></div>
          
          {/* Bulle d'aide */}
          <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 w-64 relative">
            <p className="text-sm text-gray-700 leading-relaxed">
              Hey ! Je peux t&apos;aider à rechercher quelque chose sur Otulaa
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
